import { useCallback, useLayoutEffect, useMemo, useState, type ReactNode } from "react";

import {
  LoadGateApiContext,
  LoadGateReadyContext,
  type LoadGateApi,
} from "./use-embarcacao-detail-load-gate";

/**
 * Agrupa o carregamento das seções do detalhamento: o Exportar só libera
 * quando nenhuma consulta (nem as imagens da galeria) está pendente.
 */
export function EmbarcacaoDetailLoadGateProvider({ children }: { readonly children: ReactNode }) {
  const [items, setItems] = useState<ReadonlyMap<string, boolean>>(() => new Map());
  const [hydrated, setHydrated] = useState(false);

  const setItem = useCallback((key: string, pending: boolean) => {
    setItems((previous) => {
      if (previous.get(key) === pending) return previous;
      const next = new Map(previous);
      next.set(key, pending);
      return next;
    });
  }, []);

  const removeItem = useCallback((key: string) => {
    setItems((previous) => {
      if (!previous.has(key)) return previous;
      const next = new Map(previous);
      next.delete(key);
      return next;
    });
  }, []);

  const api = useMemo<LoadGateApi>(() => ({ setItem, removeItem }), [setItem, removeItem]);

  useLayoutEffect(() => {
    setHydrated(true);
  }, []);

  const isContentReady = hydrated && [...items.values()].every((pending) => !pending);

  return (
    <LoadGateApiContext.Provider value={api}>
      <LoadGateReadyContext.Provider value={isContentReady}>
        {children}
      </LoadGateReadyContext.Provider>
    </LoadGateApiContext.Provider>
  );
}
